import {
  PiggyBank,
  HandCoins,
  Coins,
  CreditCard,
  Shield,
  Landmark,
  ArrowDownToLine,
  ArrowUpFromLine,
  Bitcoin,
  Clock
} from 'lucide-vue-next'
import type { IBranchCard } from '~/components/entity/branch'
import {
  branchTypeLabels,
  organizationTypeLabels,
  serviceLabels
} from '~/components/entity/branch/mocks'

export const useEntityBranch = () => {
  const { t } = useI18n()

  const getTypeLabels = (types: IBranchCard['types']) => {
    const labels: string[] = []
    Object.entries(types).forEach(([key, value]) => {
      if (value && branchTypeLabels[key]) {
        labels.push(t(branchTypeLabels[key]))
      }
    })
    return labels
  }

  const getOrganizationTypeLabel = (type: string) => {
    return organizationTypeLabels[type] ? t(organizationTypeLabels[type]) : type
  }

  const formatAddress = (address: string) => {
    return address.replace(/<br>/g, ' ')
  }

  const formatOpeningHours = (hours: string) => {
    return hours.replace(/<br>/g, '\n')
  }

  const getBranchTitle = (item: IBranchCard) => {
    const organizationName = item.title || item.organization.title
    if (item.is_head) return organizationName
    const typeLabels = getTypeLabels(item.types)
    const primaryType = typeLabels.length > 0 ? typeLabels[0] : t('page.map.branch_badges.branch')
    return `${primaryType} ${organizationName}`
  }

  const getServiceIcon = (serviceKey: string) => {
    const iconMap: Record<string, typeof PiggyBank> = {
      deposits: PiggyBank,
      credits: HandCoins,
      micro_credits: Coins,
      credit_cards: CreditCard,
      debit_cards: CreditCard,
      insurance: Shield,
      partners_atms: Landmark,
      'cash-in': ArrowDownToLine,
      withdrawal: ArrowUpFromLine,
      crypto: Bitcoin,
      'all-day': Clock
    }
    return iconMap[serviceKey]
  }

  const getServicesWithIcons = (services: IBranchCard['services']) => {
    const result: Array<{ key: string; label: string; icon: typeof PiggyBank }> = []
    Object.entries(services).forEach(([key, value]) => {
      if (value && serviceLabels[key]) {
        result.push({
          key,
          label: t(serviceLabels[key]),
          icon: getServiceIcon(key)
        })
      }
    })
    return result
  }

  return {
    getTypeLabels,
    getOrganizationTypeLabel,
    formatAddress,
    formatOpeningHours,
    getBranchTitle,
    getServiceIcon,
    getServicesWithIcons
  }
}
